// Lib
import React, { useEffect } from 'react';
import { FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';

// Components
import Weekly from '../../../Cart/ShippingDetails/DetailsForm/ScheduleDetails/Weekly';
import Monthly from '../../../Cart/ShippingDetails/DetailsForm/ScheduleDetails/Monthly';
import FooterButtons from '../../../Modal/FooterButtons';

// Constants
import { SHIPPING_SCHEDULES } from '../../../../constants/cart';

// Hooks
import useScheduleDetails from '../../../../pages/Cart/hooks/useScheduleDetails';
import useChangingRecurrence from '../../../../pages/OrderHistory/hooks/useChangingRecurrence';
import useModal from '../../../../hooks/useModal';

// Styles
import { useStyles } from './EditRecurrenceCardStyles';

// Actions
import { ClearShippingDetails } from '../../../../actions/cart';

const EditRecurrenceCard = ({ order, orderDetailsPage }) => {
  const dispatch = useDispatch();
  const { classes } = useStyles();
  const {
    onChangeRadio,
    setMonthError,
    isSaveBtnDisabled,
    onSave,
    loading,
    apiError,
  } = useChangingRecurrence(order, orderDetailsPage);
  const { onClose } = useModal();
  const {
    onChangeSelect,
    onChangeMultipleSelect,
    onChangeMonthlyOption,
    onChangeMonthCount,
    shippingDetails,
  } = useScheduleDetails();
  const { schedule, weekly, monthly } = shippingDetails;

  useEffect(() => {
    return () => {
      dispatch(ClearShippingDetails());
    };
  }, [dispatch]);

  return (
    <>
      <Typography variant="h3" mb={{ xs: 4 }}>
        Edit Recurrence
      </Typography>
      <RadioGroup
        className={classes.radioGroup}
        value={schedule}
        row={false}
        aria-labelledby="address-format-radio-buttons-group-label"
        name="shipping-schedule-radio-buttons-group">
        <FormControlLabel
          className={classes.radioLabel}
          value={SHIPPING_SCHEDULES[4].value}
          control={
            <Radio
              classes={{
                root: classes.radioItem,
              }}
              onChange={onChangeRadio}
            />
          }
          label={SHIPPING_SCHEDULES[4].label}
        />
        {schedule === SHIPPING_SCHEDULES[4].value && (
          <Weekly
            weekly={weekly}
            setMonthError={setMonthError}
            onChangeMonthCount={onChangeMonthCount}
            onChangeMultipleSelect={onChangeMultipleSelect}
          />
        )}
        <FormControlLabel
          className={classes.radioLabel}
          value={SHIPPING_SCHEDULES[5].value}
          control={
            <Radio
              classes={{
                root: classes.radioItem,
              }}
              onChange={onChangeRadio}
            />
          }
          label={SHIPPING_SCHEDULES[5].label}
        />
        {schedule === SHIPPING_SCHEDULES[5].value && (
          <Monthly
            monthly={monthly}
            onChangeMonthlyOption={onChangeMonthlyOption}
            onChangeSelect={onChangeSelect}
            onChangeMonthCount={onChangeMonthCount}
            setMonthError={setMonthError}
          />
        )}
      </RadioGroup>
      {apiError && <div className={classes.accent}>{apiError}</div>}
      <FooterButtons
        className={classes.buttons}
        onReject={onClose}
        onAccept={onSave}
        acceptTitle="Save"
        rejectTitle="Cancel"
        disabledAcceptBtn={isSaveBtnDisabled}
        isLoading={loading}
      />
    </>
  );
};

export default EditRecurrenceCard;
